import { Box, Stack } from '@mui/material'
import React from 'react'
import { TimelineCaregiverTeamMemberControlAdd } from '../TimelineCaregiverTeamMemberAdd/TimelineCaregiverTeamMemberControlAdd'
import { TimelineTeamControlSelect } from '../TimelineTeamControlSelect/TimelineTeamControlSelect'
import { TimelineTeamMembers } from '../TimelineTeamMembers/TimelineTeamMembers'
import * as Styled from './TimelineJourneyMembersTab.styled'

export function TimelineJourneyMembersTab() {
  return (
    <Stack paddingLeft={{ xs: 2 }} paddingRight={1} spacing={1}>
      <Styled.TeamControlsContainer>
        <TimelineTeamControlSelect />

        <Styled.TeamControls>
          <TimelineCaregiverTeamMemberControlAdd />
        </Styled.TeamControls>
      </Styled.TeamControlsContainer>

      <Box sx={{ marginBottom: '80px' }}>
        <TimelineTeamMembers />
      </Box>
    </Stack>
  )
}
